<div class="top" *ngIf="!!chainName || !!restaurant || !!backLink">
  <div class="content">
    <div *ngIf="!backLink"></div>
    <button
      class="back"
      *ngIf="backLink"
      (click)="back()"
    >
      <fa-icon [icon]="icons.back"></fa-icon>
      <span>{{ 'navigation.back' | translate }}</span>
    </button>
    <div class="names">
      <span *ngIf="chainName">{{chainName}}</span>
      <div class="names__restaurant" *ngIf="restaurant">
        <a class="navigate_item" [routerLink]="['/restaurants', prevRestaurant?.id, 'tables']">
          <fa-icon *ngIf="prevRestaurant" [icon]="icons.back"></fa-icon>
          <span class="navigate_item__name">{{prevRestaurant?.name}}</span>
        </a>
        <div class="current_name" [matTooltip]="restaurant ? restaurant.name : ''">
          {{restaurant?.name}}
        </div>
        <a class="navigate_item" [routerLink]="['/restaurants', nextRestaurant?.id, 'tables']">
          <span class="navigate_item__name">{{nextRestaurant?.name}}</span>
          <fa-icon *ngIf="nextRestaurant" [icon]="icons.next"></fa-icon>
        </a>
      </div>
    </div>
    <div class="top__logout">
      <button type="button" (click)="confirmToLogout()">
        <span>{{ 'navigation.logOut' | translate }}</span>
        <fa-icon [icon]="icons.logout"></fa-icon>
      </button>
    </div>
  </div>
</div>
<div class="app-header" [class.solo]="!chainName && !restaurant?.name && !backLink">
  <div class="app-header__logo">
    <img src="/assets/icons/oongalee-logo.svg" alt="Logo">
  </div>

  <div class="app-header__menu" *ngIf="links">
    <ul>
      <li
        *ngFor="let link of links"
        class="app-header__menu-item"
        [routerLink]="[link.route]"
        routerLinkActive="active"
      >
        <a>{{ link.title | translate }}</a>
      </li>
    </ul>
  </div>
  <div class="app-header__logout" *ngIf="!chainName && !restaurant && !backLink">
    <button class="btn btn__link" (click)="confirmToLogout()">
      <span>{{ 'navigation.logOut' | translate }}</span>
      <fa-icon [icon]="icons.logout"></fa-icon>
    </button>
  </div>
</div>
